import React, { useState, useEffect } from "react";

import {
  Container,
  Content,
  Title,
  Pagination,
  Opcoes,
  Table,
  Button,
  Label,
  Back,
} from "./styles";

import { withRouter } from "react-router-dom";
import swal from "sweetalert";

import { MdDelete, MdAdd, MdCreate, MdKeyboardBackspace } from "react-icons/md";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";
import { producaov2 as api } from "../../../../services/apis";

import { Form, Input } from "semantic-ui-react";

const WebserieEpisodios = () => {
  const [playlist, setPlaylist] = useState(null);
  const [search, setSearch] = useState(null);
  const [reload, setReload] = useState(false);
  const [filtro, setFiltro] = useState(null);

  useEffect(() => {
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const deletePlaylist = async (id) => {
    api
      .delete(`/admin/webseries_playlist/${id}`)
      .then((res) => {
        swal(
          `Deletado com sucesso - Playlist: ${res.data.id} - ${res.data.titulo} `
        );
        setReload(!reload);
      })
      .catch((err) => swal("Não foi possível deletar os dados", err.message));
  };

  useEffect(() => {
    if (search === "" || search === null) {
      api
        .get(`webseries_playlist?ativa=${filtro}`)
        .then((res) => setPlaylist(res.data))
        .catch((err) =>
          swal("Não foi possível consultar os dados - ", err.message)
        );
    } else {
      api
        .get(`/webseries/playlist/${search}`)
        .then((res) => {
          console.log(res);
          if (res.data.status === "erro") {
            setPlaylist([]);
          } else {
            setPlaylist([res.data]);
          }
        })
        .catch((err) => {
          console.log("Não foi possível pegar os dados - ", err.message);
        });
    }
  }, [filtro, search, reload]);

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back>
            <MdKeyboardBackspace
              onClick={() => (window.location.href = "/admin/webseries")}
            />
          </Back>
          <Title> Gerenciamento de Playlist </Title>

          <Form>
            <Button
              onClick={() =>
                window.open("/admin/webserie-playlist/criar", "_self")
              }
            >
              {" "}
              Criar <MdAdd />{" "}
            </Button>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Busque pelo ID da Playlist"
                placeholder="Busque pelo ID da Playlist"
                type={"number"}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Label> Filtro por playlist ativa </Label>
              <select onChange={(e) => setFiltro(e.target.value)}>
                <option value={null}> Sem filtro </option>
                <option value={"1"}> Ativa </option>
                <option value={"0"}> Não Ativa </option>
              </select>
            </Form.Group>
          </Form>
          <Table>
            {playlist?.map((item) => (
              <tr>
                <td> {item.id || search} </td> <td> {item.titulo} </td>{" "}
                {console.log(item)}
                <td onClick={() => deletePlaylist(item.id)}>
                  {" "}
                  <MdDelete />{" "}
                </td>{" "}
                <td
                  onClick={() =>
                    window.open(`/admin/webserie-playlist/update?${item.id}`)
                  }
                >
                  <MdCreate />
                </td>
              </tr>
            ))}
          </Table>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(WebserieEpisodios);
